import {
  Spaceable
} from "./chunk.G3SZKTQJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-location-overview/jb-location-overview.scss?inline
var jb_location_overview_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.wrapper h2, .wrapper, .wrapper h3 {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

.wrapper h3 {
  font-size: var(--theme-typo-p-big-mobile-fontsize, 1.188rem);
  line-height: var(--theme-typo-p-big-mobile-lineheight, 1.75rem);
}
@media (min-width: 1281px) {
  .wrapper h3 {
    font-size: var(--theme-typo-p-big-desktop-fontsize, 1.375rem);
    line-height: var(--theme-typo-p-big-desktop-lineheight, 2.125rem);
  }
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

.wrapper {
  column-count: 1;
  gap: 0;
  margin: 0;
}
@media (min-width: 600px) {
  .wrapper {
    column-count: 2;
  }
}
@media (min-width: 960px) {
  .wrapper {
    column-count: 3;
  }
}
.wrapper h2 {
  font-size: 1.375rem;
  letter-spacing: 0.125rem;
  line-height: 100%;
  padding-block-end: var(--spacing-m);
  text-transform: uppercase;
}
.wrapper h3 {
  margin-block-end: var(--spacing-2xs);
}
.wrapper .region-wrapper {
  break-inside: avoid;
  margin-block-end: var(--spacing-3xl);
  page-break-inside: avoid;
}
@media (min-width: 600px) {
  .wrapper .region-wrapper {
    padding-inline: var(--spacing-s);
  }
}
.wrapper .region-wrapper .country-wrapper {
  border-block-end: 1px solid rgba(20, 30, 85, var(--theme-opacity-20, 0.2));
  display: flex;
  flex-wrap: wrap;
  margin-block-end: var(--spacing-s);
  padding-block-end: calc(var(--spacing-xs) - var(--spacing-2xs));
}
.wrapper .region-wrapper .country-wrapper li {
  inline-size: 50%;
  list-style: none;
  padding-block-end: var(--spacing-2xs);
}
.wrapper .region-wrapper .country-wrapper li a {
  color: rgba(20, 30, 85, var(--theme-opacity-70, 0.7));
  font-size: 0.625rem;
  font-weight: 500;
  letter-spacing: 0.094rem;
  line-height: 1rem;
  text-decoration: none;
  text-transform: uppercase;
  transition: color 0.3s ease-in-out 0s;
}
.wrapper .region-wrapper .country-wrapper li a:hover {
  color: rgba(20, 30, 85, var(--theme-opacity-40, 0.4));
  transition: color 0.3s ease-in-out 0s;
}`;

// src/components/jb-location-overview/jb-location-overview.ts
var JbLocationOverview = class extends Spaceable(h) {
  _getContentSpacingProperties() {
    return { colsMdUp: 12, colsLgUp: 10, grid: true };
  }
  render() {
    return ke`
      <div class="wrapper">
        ${this.regions.map(
      (region) => ke`<div class="region-wrapper">
              <h2>${region.title}</h2>
              ${region.countries.map(
        (country) => ke`<h3>${country.title}</h3>
                    <div class="country-wrapper">
                      ${country.locations.map(
          (location) => ke`<li><a href=${location.link.href}>${location.title}</a></li>`
        )}
                    </div>`
      )}
            </div>`
    )}
      </div>
    `;
  }
};
JbLocationOverview.styles = r(jb_location_overview_default);
__decorateClass([
  n({ type: Array })
], JbLocationOverview.prototype, "regions", 2);
JbLocationOverview = __decorateClass([
  customElement("jb-location-overview")
], JbLocationOverview);

export {
  JbLocationOverview
};
